import { useEffect, useState } from 'react'

const DARK_QUERY = '(prefers-color-scheme: dark)'

function isDark(): boolean {
  return (
    window.matchMedia(DARK_QUERY).matches &&
    !document.documentElement.classList.contains('light-only')
  )
}

/**
 * Whether the page is drawn dark, for what CSS cannot reach: the map's tiles
 * and the toasts. It is the stylesheet's own rule (tokens.css): the operating
 * system's dark mode, unless the page stays light for a logo with no dark
 * variant (logbook decision 26), which the shell marks with `light-only` on
 * <html>. A module reads its host's root the same way and only reads it; a
 * host that marks a nearer ancestor instead keeps the module's styles light,
 * and the map follows the device.
 */
export function useDarkScheme(): boolean {
  const [dark, setDark] = useState(isDark)

  useEffect(() => {
    const update = () => setDark(isDark())
    const mq = window.matchMedia(DARK_QUERY)
    mq.addEventListener('change', update)
    const observer = new MutationObserver(update)
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    update()
    return () => {
      mq.removeEventListener('change', update)
      observer.disconnect()
    }
  }, [])

  return dark
}
